import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { Button } from '../ui/button';
import { Logo } from '../Logo';
import NotificationBell from '../NotificationBell';
import WorkspaceSwitcher from '../WorkspaceSwitcher';
import { LogOut, Search, ArrowLeft } from 'lucide-react';

export function ClientHeader({ title, subtitle, backTo, children }) {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  return (
    <div className="bg-card border-b sticky top-0 z-30">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center py-4">
          <div className="flex items-center gap-4 min-w-0">
            {backTo ? (
              <Button
                variant="ghost"
                size="sm"
                onClick={() => navigate(backTo)}
                data-testid="client-header-back-btn"
              >
                <ArrowLeft className="h-4 w-4 mr-1" /> Back
              </Button>
            ) : (
              <Logo variant="compact" size="sm" />
            )}
            <div className="hidden sm:block border-l pl-4 min-w-0">
              <h1 className="text-lg font-semibold truncate" data-testid="client-page-title">
                {title || `Welcome, ${user?.name?.split(' ')[0] || 'there'}`}
              </h1>
              <p className="text-sm text-muted-foreground truncate">{subtitle || user?.email}</p>
            </div>
          </div>
          <div className="flex gap-2 items-center">
            {children}
            <WorkspaceSwitcher />
            <NotificationBell />
            <Button
              variant="outline"
              size="sm"
              onClick={() => navigate('/')}
              data-testid="browse-providers-btn"
            >
              <Search className="h-4 w-4 mr-1" /> <span className="hidden sm:inline">Find a Provider</span>
            </Button>
            <Button variant="outline" size="sm" onClick={handleLogout} data-testid="client-logout-btn">
              <LogOut className="h-4 w-4 mr-1" /> <span className="hidden sm:inline">Logout</span>
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}
